(() => {
  const interactionQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const radius = 220;
  const maxShift = 24;
  const neighborStrength = 0.28;
  const lerpFactor = 0.08;

  const initializePhotoInteraction = (section) => {
    if (!section || section.dataset.photoInteractionInitialized === 'true') return;

    section.dataset.photoInteractionInitialized = 'true';
    if (!interactionQuery.matches || reducedMotionQuery.matches) return;

    const photos = Array.from(section.querySelectorAll('.ft-brand-story__photo'));
    if (!photos.length) return;

    const states = photos.map((element) => ({
      element,
      centerX: 0,
      centerY: 0,
      currentX: 0,
      currentY: 0,
      currentRotation: 0,
      currentScale: 1,
      targetX: 0,
      targetY: 0,
      targetRotation: 0,
      targetScale: 1
    }));

    let animationFrame = null;

    const setBaseCenters = () => {
      states.forEach((state) => {
        const rect = state.element.getBoundingClientRect();
        state.centerX = rect.left + rect.width / 2;
        state.centerY = rect.top + rect.height / 2;
      });
    };

    const resetTargets = () => {
      states.forEach((state) => {
        state.targetX = 0;
        state.targetY = 0;
        state.targetRotation = 0;
        state.targetScale = 1;
        state.element.style.zIndex = '2';
      });
    };

    const render = () => {
      let unsettled = false;

      states.forEach((state) => {
        state.currentX += (state.targetX - state.currentX) * lerpFactor;
        state.currentY += (state.targetY - state.currentY) * lerpFactor;
        state.currentRotation += (state.targetRotation - state.currentRotation) * lerpFactor;
        state.currentScale += (state.targetScale - state.currentScale) * lerpFactor;

        state.element.style.setProperty('--ft-story-shift-x', `${state.currentX.toFixed(3)}px`);
        state.element.style.setProperty('--ft-story-shift-y', `${state.currentY.toFixed(3)}px`);
        state.element.style.setProperty('--ft-story-interaction-rotation', `${state.currentRotation.toFixed(3)}deg`);
        state.element.style.setProperty('--ft-story-interaction-scale', state.currentScale.toFixed(5));

        if (
          Math.abs(state.targetX - state.currentX) > 0.08 ||
          Math.abs(state.targetY - state.currentY) > 0.08 ||
          Math.abs(state.targetRotation - state.currentRotation) > 0.01 ||
          Math.abs(state.targetScale - state.currentScale) > 0.0001
        ) unsettled = true;
      });

      if (unsettled) {
        animationFrame = window.requestAnimationFrame(render);
      } else {
        animationFrame = null;
        if (states.every((state) => state.targetX === 0 && state.targetY === 0)) {
          section.classList.remove('is-photo-interacting');
        }
      }
    };

    const requestRender = () => {
      section.classList.add('is-photo-interacting');
      if (animationFrame === null) animationFrame = window.requestAnimationFrame(render);
    };

    const handleMouseMove = (event) => {
      const affected = states
        .map((state) => {
          const deltaX = state.centerX - event.clientX;
          const deltaY = state.centerY - event.clientY;
          return { state, deltaX, deltaY, distance: Math.hypot(deltaX, deltaY) };
        })
        .filter((item) => item.distance < radius)
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 3);

      resetTargets();

      affected.forEach((item, index) => {
        const strength = Math.max(0, 1 - item.distance / radius);
        const influence = index === 0 ? 1 : neighborStrength;
        const safeDistance = item.distance || 1;
        const directionX = item.deltaX / safeDistance;
        const directionY = item.deltaY / safeDistance;
        const shift = maxShift * strength * influence;

        item.state.targetX = directionX * shift;
        item.state.targetY = directionY * shift;
        item.state.targetRotation = directionX * strength * (index === 0 ? 1.5 : 0.4);
        item.state.targetScale = index === 0 ? 1 + 0.015 * strength : 1;
        item.state.element.style.zIndex = index === 0 ? '5' : '3';
      });

      requestRender();
    };

    const handleMouseEnter = () => {
      setBaseCenters();
      section.addEventListener('mousemove', handleMouseMove);
    };

    const handleMouseLeave = () => {
      section.removeEventListener('mousemove', handleMouseMove);
      resetTargets();
      requestRender();
    };

    section.addEventListener('mouseenter', handleMouseEnter);
    section.addEventListener('mouseleave', handleMouseLeave);
  };

  const initializeAllPhotoInteractions = (root = document) => {
    root.querySelectorAll('.ft-brand-story').forEach(initializePhotoInteraction);
  };

  initializeAllPhotoInteractions();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllPhotoInteractions(event.target);
  });
})();
